import gz from './gz';

export default {
  gzApi: gz,
}
